'use strict';

const processInclude = require('base/util');

if ($('.js-videoControl').length > 0) {
    var video = require('./product/productDetailVideo');
    video.loadVideo();
}

$(document).ready(function () {
    processInclude(require('./product/productDetail'));
    processInclude(require('./product/detail'));
    processInclude(require('./product/stickyBar'));
});
